/**
 * Created by: cparaschiv
 * Date: 24.09.2013, 18:42
 */

(function ($, undefined) {
    'use strict';

    var kendo = window.kendo,
        activeElement = kendo._activeElement,
        extractFormat = kendo._extractFormat,
        ui = kendo.ui,
        Widget = ui.Widget,
        OPEN = "open",
        CLOSE = "close",
        VALUE = "value",
        TEXT = "text",
        CHANGE = "change",
        CHANGE_TEXT = "changetext",
        ns = ".kendoBrowsePicker",
        cls = 'k-browsepicker',
    //cls = 'k-datetimepicker',
        CLICK = "click" + ns,
        DISABLED = "disabled",
        READONLY = "readonly",
        DEFAULT = "k-state-default",
        FOCUSED = "k-state-focused",
        HOVER = "k-state-hover",
        STATEDISABLED = "k-state-disabled",
        HOVEREVENTS = "mouseenter" + ns + " mouseleave" + ns,
        MOUSEDOWN = "mousedown" + ns,
        SPAN = "<span/>",
        ARIA_DISABLED = "aria-disabled",
        ARIA_READONLY = "aria-readonly",
        extend = $.extend,
        unwrap = TS.unwrap,
        primitiveTypes = {'undefined': 1, 'boolean': 1, 'number': 1, 'string': 1};

    function isDifferent(a, b) {
        if (a === "")
            a = null;
        if (b === "")
            b = null;
        var oldValueIsPrimitive = (a === null) || (typeof (a) in primitiveTypes);
        return !(oldValueIsPrimitive ? (a === b) : false);
    }

    function preventDefault(e) {
        e.preventDefault();
    }

    var TsBrowsePicker = Widget.extend({

        browseProperty: null,

        init: function (element, options) {
            var that = this, disabled,
                propName = options.browseList,
                vm;

            if (!propName)
                throw new Error('Configuration does not contain the name of the browse list property');

            Widget.fn.init.call(that, element, options);

            element = that.element;
            options = that.options;

            that._wrapper();
            that._icons();
            that._reset();
            that._template();

            element[0].type = "text";
            element.addClass("k-input")
                .attr({
                    "role": "textbox",
                    "aria-haspopup": true,
                    "aria-expanded": false
                });

            that._enabled = !element.is("[disabled]");
            that._readonly = (element.is("[readonly]"));

            that._editable({
                enabled: that._enabled,
                readonly: that._readonly,
                allowInput: options.hasOwnProperty('allowInput') ? options.allowInput : true
            });

            vm = options.getViewModel();
            if (!vm) {
                TS.Log.warn('Cannot get view model for widget [' + element.attr('id') + ']');
                return;
            }


            if (vm && typeof propName == 'string') {
                that.browseProperty = TS.Util.getProperty(vm, propName);
            }

            /*if (!options.embedded) {
                that.browseProperty = TS.Util.getProperty(vm, options.browseList);
            } else {
                // when editing a grid row, the target model is the row
                that._targetModel = vm;
                if (that._targetModel) {
                    that.browseProperty._targetModel = that._targetModel;
                }
            }*/

            kendo.notify(that);
        },

        options: {
            name: "TsBrowsePicker",
            value: null,
            footer: "",
            animation: {},
            ARIATemplate: 'Current value is ?'
        },

        events: [
            OPEN,
            CLOSE,
            CHANGE
        ],

        setOptions: function (options) {
            var that = this;

            Widget.fn.setOptions.call(that, options);
            options = that.options;
            //that.timeView.ul[0].innerHTML = "";
        },

        _editable: function (opts) {
            var me = this,
                readonly, enabled, allowInput,
                element = me.element.off(ns),
                wrapper = me._inputWrapper.off(ns),
                browseButton = me._browseButton.off(ns),
                clearButton = me._clearButton.off(ns),
                changeText;

            allowInput = opts.hasOwnProperty('allowInput') ? opts.allowInput : true;
            readonly = opts.hasOwnProperty('readonly') ? opts.readonly : me._readonly;
            enabled = opts.hasOwnProperty('enabled') ? opts.enabled : me._enabled;

            if (allowInput === false)
                readonly = true;

            me._readonly = readonly;
            me._enabled = enabled;
            me._allowInput = allowInput;

            wrapper.addClass(enabled ? DEFAULT : STATEDISABLED)
                .removeClass(enabled ? STATEDISABLED : DEFAULT);

            element.attr(DISABLED, !enabled)
                .attr(READONLY, readonly)
                .attr(ARIA_DISABLED, !enabled)
                .attr(ARIA_READONLY, readonly);

            if (enabled) {
                wrapper.on(HOVEREVENTS, me._toggleHover);

                if (!readonly) {
                    changeText = function () {
                        if (element.val() !== me._oldText) {
                            me._changeText(element.val());
                        }
                    };

                    element.on("focus" + ns, function () {
                        me._inputWrapper.addClass(FOCUSED);
                    })
                        .on("blur" + ns, function () {
                            me._inputWrapper.removeClass(FOCUSED);
                            changeText();
                        });
                }

                browseButton.on(MOUSEDOWN, preventDefault)
                    .on(CLICK, function () {
                        TS.trace('first icon clicked');

                        if (!kendo.support.touch && element[0] !== activeElement()) {
                            element.focus();
                        }

                        if (changeText)
                            changeText();
                        me._showBrowser();
                    });

                clearButton.on(MOUSEDOWN, preventDefault)
                    .on(CLICK, function () {
                        TS.trace('second icon clicked');

                        me._changeText('');
                        me._changeVal(null);
                        me.browseProperty.SelectedItem(null);
                        me.browseProperty.reset();

                        if (!kendo.support.touch && element[0] !== activeElement()) {
                            element.focus();
                        }
                    });
            }
        },

        enable: function (enabled) {
            this._editable({
                enabled: enabled
            })
        },

        readonly: function (readonly) {
            this._editable({
                readonly: readonly
            })
        },

        destroy: function () {
            var that = this;

            Widget.fn.destroy.call(that);

            that.valueElement.off(ns);
            that.element.off(ns);
            that._browseButton.off(ns);
            that._clearButton.off(ns);
            that._inputWrapper.off(ns);

            if (that._form) {
                that._form.off("reset", that._resetHandler);
            }
        },

        selectValue: function (item, dataRow) {
            var me = this,
                val, txt;

            try {
                val = item[me.browseProperty.ValueMember];
            }
            catch (err) {
                TS.Log.warn('Cannot read value property [' + me.browseProperty.ValueMember + '] from selected item');
            }
            try {
                txt = item[me.browseProperty.ListMember];
            }
            catch (err) {
                TS.Log.warn('Cannot read text property [' + me.browseProperty.ListMember + '] from selected item');
            }

            me._changeText(txt);
            me._changeVal(val);

            me.browseProperty.SelectedItem(item);
            me.browseProperty.Value(val);
            me.browseProperty.DisplayValue(txt);
        },

        value: function (val) {
            var that = this;

            if (val === undefined) {
                return that._value;
            }

            that._oldVal = that._updateVal(val);
            if (that._oldVal === null) {
                that.valueElement.val(null);
            }

            that._oldVal = val;
            that._value = val;
        },

        text: function (txt) {
            var that = this;

            if (txt === undefined) {
                return that._text;
            }

            that._oldText = that._updateText(txt);
            if (that._oldText === null) {
                that.element.val("");
            }

            that._oldText = txt;
            that._text = txt;
        },

        _changeVal: function (val) {
            var that = this;

            val = that._updateVal(val);

            if (isDifferent(that._oldVal, val)) {
                that._oldVal = that.valueElement.val();
                that.trigger(CHANGE);
                that.valueElement.trigger(CHANGE);
            }
        },

        _changeText: function (val) {
            var that = this;

            val = that._updateText(val);

            if (isDifferent(that._oldText, val)) {
                that._oldText = that.element.val();
                that.trigger(CHANGE_TEXT);
                that.valueElement.trigger(CHANGE_TEXT);
            }
        },

        _updateVal: function (val) {
            var that = this;
            that._value = val;
            that.valueElement.val(val);
            return val;
        },

        _updateText: function (txt) {
            var that = this;
            that._text = txt;
            that.element.val(txt);
            return txt;
        },

        _option: function (option, value) {
            var that = this,
                options = that.options;

            if (value === undefined) {
                return options[option];
            }

            value = parse(value, options.parseFormats, options.culture);

            if (!value) {
                return;
            }
        },

        _toggleHover: function (e) {
            $(e.currentTarget).toggleClass(HOVER, e.type === "mouseenter");
        },

        _icons: function () {
            var that = this,
                element = that.element,
                icons;

            icons = element.next("span.k-select");

            if (!icons[0]) {
                icons = $('<span unselectable="on" class="k-select"><span unselectable="on" class="k-icon k-i-search">browse</span><span unselectable="on" class="k-icon k-i-close">clear</span></span>').insertAfter(element);
            }

            icons = icons.children();
            that._browseButton = icons.eq(0).attr({
                "role": "button"
            });

            that._clearButton = icons.eq(1).attr({
                "role": "button"
            });
        },

        _wrapper: function () {
            var that = this,
                element = that.element,
                valueElem,
                wrapper;

            wrapper = element.parents("." + cls);

            if (!wrapper[0]) {
                wrapper = element.wrap(SPAN).parent().addClass("k-picker-wrap k-state-default");
                wrapper = wrapper.wrap(SPAN).parent();
            }

            wrapper[0].style.cssText = element[0].style.cssText;
            element.css({
                width: "100%",
                height: element[0].style.height
            });

            that.wrapper = wrapper.addClass('k-widget ' + cls + ' k-header')
                .addClass(element[0].className);

            that._inputWrapper = $(wrapper[0].firstChild);

            // create an additional input element that will hold the value
            // the existing element will hold the text
            valueElem = $('<input>').attr({
                type: 'hidden',
                id: $(element).attr('id') + '-val',
                name: $(element).attr('name') + '-val'
            }).appendTo(wrapper);

            that.valueElement = valueElem;
        },

        _reset: function () {
            var that = this,
                element = that.element,
                form = element.closest("form");

            if (form[0]) {
                that._resetHandler = function () {
                    that.value(element[0].defaultValue);
                };

                that._form = form.on("reset", that._resetHandler);
            }
        },

        _template: function () {
            this._ariaTemplate = kendo.template(this.options.ARIATemplate);
        },

        _updateARIA: function (date) {
            this.element.attr("aria-label", this._ariaTemplate({current: date}));
        },

        _showBrowser: function () {
            var me = this,
                url = me.browseProperty.browseUrl,
                property = me.browseProperty,
                domain = property.Domain(),
                urlParams;


            TS.trace('showing browser...');

            if (!url) {
                TS.Notify.error('Invalid URL for browser.');
                return;
            }

            urlParams = kendo.parseQueryStringParams(url);
            urlParams = $.extend(urlParams, {
                popup: true,
                modelUID: TS.unwrap(domain.modelUID),
                subDomain: domain.subdomainPath,
                name: TS.unwrap(property.name)
            });

            url = url.split("?")[0] + "?" + $.param(urlParams);

            TS.UI.Mask.show();
            domain.ajax(url, {
                type: "POST",
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                data: JSON.stringify({textValue: this.text(), modelData: ko.mapping.toJSON(domain._getData())}),
                cache: false
            }, {
                viewDomain: function (options) {
                    TS.UI.viewDomain(options, $.proxy(me._onBrowserShown, me));
                }
            });
            ;
        },

        _onBrowserShown: function (model) {
            var me = this;

            TS.trace('browser: shown');

            me.isOpened = true;

            model.on('close', function () {
                TS.trace('browser: closed');
                me.isOpened = false;
            });

            var selectCommand = model.getCommand('Record.PopupSelect');
            selectCommand.handler = function () {
                var selection = model.SelectedRows,
                    firstItem = selection && $.isArray(selection) && (selection.length > 0) && selection[0],
                    selectValue = function () {
                        model.un('close', selectValue);
                        // regular browse control, has method 'selectValue'
                        if (me.selectValue) {
                            me.selectValue(firstItem, firstItem);
                        }
                    };

                model.on('close', selectValue);
                model.close(true, true, true);
            };
        }
    });

    ui.plugin(TsBrowsePicker);

    ko.kendo.bindingFactory.createBinding({
        name: "kendoTsBrowsePicker",
        events: {
            change: VALUE,
            changetext: TEXT
        },
        watch: {
            enabled: 'enable',
            readonly: READONLY,
            isOpen: [OPEN, CLOSE],
            value: VALUE,
            text: TEXT,
            visible: ko.wrapperVisible
        }
    });

    var prevBrowserSetup = ko.bindingHandlers['kendoTsBrowsePicker'].setup;
    ko.bindingHandlers['kendoTsBrowsePicker'].setup = function (element, options, context) {

        options.getViewModel = function () {
            var vm = context.$data;
            return vm;
        };

        if (options.browseList) {
            var browseList = TS.getPropertyValue(context.$data, options.browseList);
            if (browseList) {
                options.value = TS.accessor(browseList.Domain(), ts.unwrap(browseList.EditMember)).value;
                options.text = TS.accessor(browseList.Domain(), ts.unwrap(browseList.DisplayMember)).value;
            }
        }

        prevBrowserSetup.apply(this, arguments);
    };


})(window.kendo.jQuery);